<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.3492 6.50918C25.2227 6.09284 27 7.5185 27 9.43774V20.0068C27 21.9261 25.2227 23.3517 23.3492 22.9354L14.46 20.96L16.897 25.5293L15.1323 26.4705L11.8886 20.3886L7.34921 19.3798C5.9766 19.0748 5 17.8574 5 16.4513V12.9933C5 11.5872 5.9766 10.3698 7.34921 10.0647L23.3492 6.50918ZM25 9.43774C25 8.79799 24.4076 8.32277 23.7831 8.46155L20.3334 9.22815L20.3334 20.2164L23.7831 20.983C24.4076 21.1218 25 20.6466 25 20.0068V9.43774ZM7.78307 12.0171L18.3334 9.6726L18.3334 19.772L7.78307 17.4275C7.32553 17.3258 7 16.92 7 16.4513L7 12.9933C7 12.5246 7.32553 12.1188 7.78307 12.0171Z"
        />
    </g>
</template>
